import { darken, lighten } from "@mui/material/styles";

/**
 * Полноэкранные меню-диалоги: paper = фон арены (body), шапка на ~1% в HSL:
 * тёмная тема — чуть светлее body, светлая — чуть темнее.
 */
export function getFullScreenMenuDialogSurfaces(theme) {
  const bodyBg = theme.palette.background.body;
  const headerBg =
    theme.palette.mode === "light"
      ? darken(bodyBg, 0.01)
      : lighten(bodyBg, 0.01);
  const paperSx = {
    bgcolor: bodyBg,
    backgroundImage: "none",
    "&&": {
      backgroundColor: bodyBg,
    },
  };
  const headerSx = {
    bgcolor: headerBg,
    backgroundImage: "none",
    "&&": {
      backgroundColor: headerBg,
    },
  };
  return { paperProps: { sx: paperSx }, headerSx };
}
